import axios from "axios";
import BASE_URL from "../../assets/global/url";

// Saved split lines of a Profit Distribution (all owners)
export const getFundAllocations = async (profitDistributionId) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/profit_distribution/getFundAllocations`,
      { params: { profit_distribution_id: profitDistributionId } },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
